/**
 * created by wang lei
 编辑器上方按钮下拉菜单
 *
 */
import React, {Component} from 'react';
import { Icon } from 'antd';
import onClickOutside from "react-onclickoutside";

class SelectBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            thisCheck:false,
        }
    }

    render() {
        return (
            <span>
                {this.props.children}
                <div style={{display: this.props.visible ? 'block' : 'none',position: 'absolute',zIndex: 999, width: 180,padding: 5,borderRadius: '5px',background: '#fff',boxShadow: '0px 9px 28px rgba(0, 0, 0, 0.1)'}}>
                    {this.props.options.map(option=>{
                        return (
                            <div key={option.key} className={'editToolOption'} style={{display: 'flex',alignItems: 'center',height:20,border: '1px solid transparent'}}
                                 onClick={()=>{
                                     if(typeof this.props.onChange == 'function') {
                                         this.props.onChange(option.key);
                                         this.props.hide()
                                     }
                                 }}
                            >
                                <div style={{display: 'flex',alignItems: 'center',width: 35,height:20, borderRight: '1px solid rgba(0, 0, 0, 0.15)',}}>
                                    <Icon type="check" style={{margin: "auto", display: option.checked ? 'block' : 'none'}}/>
                                </div>
                                <div style={{display: 'flex',alignItems: 'center',paddingLeft:'5px'}}>{option.val}</div>
                            </div>
                        )
                    })}
                    <style>
                        {
                            `.editToolOption:hover { background: #fff5d4 ;border-color: #dcac6c;}`
                        }
                    </style>
                </div>
            </span>

        )
    }
    handleClickOutside = (evt) => {
        if(typeof this.props.hide == 'function') {
            this.props.hide()
        }
    };
}
export default onClickOutside(SelectBtn);
